import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { ContactPersonCardComponent } from '../../card/contact-person-card/contact-person-card.component';
import { ContactSectionModel } from '../models/contact-section.model';

@Component({
  selector: 'mb-contact-section',
  templateUrl: './contact-section.component.html',
  styleUrls: ['./contact-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ContactPersonCardComponent],
})
export class ContactSectionComponent {
  @Input() data!: ContactSectionModel;
}
